import type { ReactNode } from 'react';
import type { ParamParseKey, Params } from 'react-router';
import { Route, Routes, useNavigate } from 'react-router';
import { useRelativeMatch } from '@/hooks/useRelativeMatch.ts';
import { Drawer } from '../Drawer';

export interface DrawerRouteProps<
    ParamKey extends ParamParseKey<Path>,
    Path extends string,
> {
    path: Path;
    anchor?: 'left' | 'top' | 'right' | 'bottom';

    render(onClose: () => void, params: Params<ParamKey>): ReactNode;

    classes?: {
        [key: string]: string;
    };
    hideClose?: boolean;
    onClose?: () => void;
}

export const DrawerRoute = <Path extends string = string>(
    props: DrawerRouteProps<ParamParseKey<Path>, Path>,
) => {
    const navigate = useNavigate();
    const match = useRelativeMatch('../' + props.path);

    const onClose = props.onClose ?? (() => navigate('..'));

    return (
        <Drawer
            anchor={props.anchor ?? 'right'}
            open={match !== null}
            onClose={onClose}
            hideCloseButton={props.hideClose}
        >
            <Routes>
                <Route
                    path={props.path}
                    element={match && props.render(onClose, match.params)}
                />
            </Routes>
        </Drawer>
    );
};
